import { isValidSiteLocale } from "@features/market/config/market-config";

export default function getLocaleFromPathname(pathname: string) {
  const locale = pathname.split("/")[1];

  return isValidSiteLocale(locale) ? locale : "";
}
